import React from 'react';

const Footer = () => (
  <div className="footer">
    <p>Dev and Design by <a href="https://twitter.com/mikecooknick">Mike Cooknick</a></p>
  </div>
)

export default Footer;